import { render, staticRenderFns } from "./Calendar2.vue?vue&type=template&id=2cce1a50&scoped=true&"
import script from "./Calendar2.vue?vue&type=script&lang=js&"
export * from "./Calendar2.vue?vue&type=script&lang=js&"
import style0 from "./Calendar2.vue?vue&type=style&index=0&id=2cce1a50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce1a50",
  null
  
)

export default component.exports